import { animate, style, transition, trigger } from '@angular/animations';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, Observable, from, interval, merge, of, timer } from 'rxjs';
import { concatMap, finalize, map, mergeMap, share, skip, tap } from 'rxjs/operators';
import { CriteriaService, GlobalService } from 'src/app/services/index.service';
import { ICategorizedQuiz } from 'src/app/shared/interfaces/categorized-quiz';
import { HorizontalBarChartSchema, IQuestionListSetting, PieChartSchema, SpiderChartSchema } from 'src/app/shared/interfaces/index.interface';
import { ISingleLikertQuestion } from 'src/app/shared/interfaces/single-likert-question';
import { ISingleMultiOptionQuestion } from 'src/app/shared/interfaces/single-multi-option-question';
import { ISingleSortingQuestion } from 'src/app/shared/interfaces/single-sorting-question';
import { SingleMultipleCriteria } from 'src/app/shared/interfaces/singleMultipleCriteria.interface';
import { ReportResultComponent } from '../../../modals/report-result/report-result.component';
import { ToastrService } from 'ngx-toastr';
import { SingleQuestionType } from 'src/app/shared/interfaces/single-question-type.interface';
import { CompleteFormService } from 'src/app/services/api/complete-form.service';

export interface IAnswer{
  id:number;
  answer:number[];
  valid:boolean;
  isUnknown:boolean;
}
interface ICharType{
  id:number,
  char:string,
  type_description:string,
  type_explain:string
}
interface IResultChart{
  id:number;
  chart_type:string;
  is_sorted_by_value:boolean,
  is_show_calculated_type:boolean,
  chart_color?:string,
  additional_fields?:{chart_color?:string}
}
enum PaginationType{
  AllInOne = 'All Question on single page',
  OneCatInOne = 'One page per question category',
  OneQuestionInOne = 'Each question on its own page',
  Custom = 'Custom number per page',
}
export const fade = trigger('fade', [
  transition(':enter', [
    style({ opacity:0 }),
    animate('0.3s ease-in', style({ opacity: 1 }))
  ])
])

@Component({
  selector: 'app-quiz',
  templateUrl: './quiz.component.html',
  styleUrls: ['./quiz.component.scss'],
  animations:[fade]
})
export class QuizComponent implements OnInit {
  @Input()questionList:(ISingleLikertQuestion|ISingleSortingQuestion|ISingleMultiOptionQuestion)[] | ICategorizedQuiz = []
  @Input()quiz:SingleMultipleCriteria = <SingleMultipleCriteria>{}
  @Input()userInfo:{name:string,phone_number?:number,email?:string}|undefined
  @Output()changecanDeactivate:EventEmitter<boolean> = new EventEmitter()
  nextPage: BehaviorSubject<boolean> = new BehaviorSubject(false)
  nextPageObs$:Observable<boolean> = this.nextPage.asObservable().pipe(
    skip(1),
    share(),
  )
  isGoNextPage:boolean = true;
  questionLists:(ISingleLikertQuestion|ISingleSortingQuestion|ISingleMultiOptionQuestion)[][] = []
  questionQuantity:number = 0
  currentPage:number = 0;
  isAnimationDisabled:boolean = true;
  time:number = 0;
  timeWarn:boolean = false;
  timerInterval:any
  timer:number = 0;//this is a timer for calc time of duration of quiz test
  progressBarValue:number = 0.00;
  isResultLoaded:boolean = false;
  examResultId:string = '1';
  resultCharts:IResultChart[] = []
  charTypeList:ICharType[] = []
  answers:IAnswer[] = []
  convertedResultCharts:(HorizontalBarChartSchema|PieChartSchema|SpiderChartSchema)[] = []
  someSubscription: any;
  isUnknownQuestionQuantityValid:boolean = true;
  isShowFinishQuizButton:boolean = false;
  isFinishQuiz:boolean = false;
  unknownAnswers:IAnswer[] = []

  constructor(
    private globalService:GlobalService,
    private router:Router,
    private dialog:MatDialog,
    private criteriaService:CriteriaService,
    private toastr:ToastrService,
    private cd: ChangeDetectorRef,
    private completeForm:CompleteFormService,
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.someSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Here is the dashing line comes in the picture.
        // You need to tell the router that, you didn't visit or load the page previously, so mark the navigated flag to false as below.
        this.router.navigated = false;
      }
    });
  }

  ngOnInit(): void {
    this.initQuestionList()
    if(this.quiz.quizlimitationsetting.time_limitation){
      this.time = this.quiz.quizlimitationsetting.time_limitation;
      // this.configTimer()
    }else{
      this.time = 9999999999;
    }
    this.configTimer()
    setTimeout(() => {
      this.isShowFinishButton()
    }, 10000);
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.globalService.scrollToTopOfView('parent', 90)
    }, 10);
  }
  changePage(nextPage:boolean){
    this.isGoNextPage = nextPage;
    this.nextPage.next(nextPage)
  }
  initQuestionList(){
    setTimeout(() => {
      this.isAnimationDisabled = false
      this.changecanDeactivate.emit(true)
    }, 200);
    if(this.quiz.quizquestionsetting.is_show_questions_grouped_by_category){
      this.questionLists = this.setCategorizedQuestionLists(Object.values(this.questionList))
    }else{
      this.questionList = <(ISingleLikertQuestion|ISingleSortingQuestion|ISingleMultiOptionQuestion)[]>this.questionList
      this.questionQuantity = this.questionList.length
      this.questionLists = this.setQuestionLists(this.questionList)
    }
  }
  setQuestionLists(questions:(ISingleLikertQuestion|ISingleSortingQuestion|ISingleMultiOptionQuestion)[]):(ISingleLikertQuestion|ISingleSortingQuestion|ISingleMultiOptionQuestion)[][]{
    let questionLists:(ISingleLikertQuestion|ISingleSortingQuestion|ISingleMultiOptionQuestion)[][] = []
    if(this.quiz.quizquestionsetting.pagination_type == PaginationType.AllInOne){
      questionLists.push(questions)
    }
    if(this.quiz.quizquestionsetting.pagination_type == PaginationType.OneQuestionInOne){
      questions.forEach((element)=>{
        questionLists.push([element])
      }) 
    }
    if(this.quiz.quizquestionsetting.pagination_type == PaginationType.Custom){
      questionLists = this.getCustomList(this.quiz.quizquestionsetting.question_count_per_page, questions)
    }
    return questionLists
  }
  setCategorizedQuestionLists(questions:(ISingleLikertQuestion|ISingleSortingQuestion|ISingleMultiOptionQuestion)[][]):(ISingleLikertQuestion|ISingleSortingQuestion|ISingleMultiOptionQuestion)[][]{
    questions.forEach(list=>this.questionQuantity+=list.length)
    let questionLists:(ISingleLikertQuestion|ISingleSortingQuestion|ISingleMultiOptionQuestion)[][] = []
    if(this.quiz.quizquestionsetting.pagination_type == PaginationType.OneCatInOne){
      questionLists = questions
    }
    if(this.quiz.quizquestionsetting.pagination_type == PaginationType.AllInOne){
      questionLists = [[]]
      questions.forEach((qList:(ISingleLikertQuestion|ISingleSortingQuestion|ISingleMultiOptionQuestion)[])=>{
        questionLists[0] = [...questionLists[0], ...qList]
      })
    }
    if(this.quiz.quizquestionsetting.pagination_type == PaginationType.OneQuestionInOne){
      questions.forEach((qList:(ISingleLikertQuestion|ISingleSortingQuestion|ISingleMultiOptionQuestion)[])=>{
        qList.forEach((q:(ISingleLikertQuestion|ISingleSortingQuestion|ISingleMultiOptionQuestion))=>{
          questionLists.push([q])
        })
      }) 
    }
    if(this.quiz.quizquestionsetting.pagination_type == PaginationType.Custom){
      questions.forEach((qList:(ISingleLikertQuestion|ISingleSortingQuestion|ISingleMultiOptionQuestion)[])=>{
        questionLists = [...questionLists, ...this.getCustomList(this.quiz.quizquestionsetting.question_count_per_page, qList)]
      })
    }
    return questionLists
  }
  getCustomList(n:number, questions:(ISingleLikertQuestion|ISingleSortingQuestion|ISingleMultiOptionQuestion)[]):(ISingleLikertQuestion|ISingleSortingQuestion|ISingleMultiOptionQuestion)[][]{
    let output:(ISingleLikertQuestion|ISingleSortingQuestion|ISingleMultiOptionQuestion)[][] = []
    let i:number = 0;
    for(let i = 0; i<questions.length; i=i+n){
      if(i+n+1>questions.length)
        output.push(questions.slice(i, questions.length))
      else
        output.push(questions.slice(i, i+n))
    }
    return output
  }
  getCategoryName(i:number):string|null|undefined{
    return Object.keys(<ICategorizedQuiz>this.questionList)[i].split('_').pop()
  }
  getQuestionListConfig(index:number):IQuestionListSetting{
    let output:IQuestionListSetting = {
      // categoryName: this.quiz.quizquestionsetting.is_show_questions_grouped_by_category?this.getCategoryName(index):null,
      firstQuestionNumber: this.getFirstQuestionNumber(index),
      inEndOfPages: index>=this.questionLists.length-1,
      pageNumber:index+1,
      isRealTime: false,
    }
    return output;
  }
  getFirstQuestionNumber(index:number):number{
    let counter:number = 1;
    for(let i=0;i<index;i++)
      counter += this.questionLists[i].length
    return counter;
  }
  configTimer(){
    this.timerInterval = setInterval(()=>{
      this.timer++;
      if(this.time){
        this.time = this.time-1
        if(this.time<=this.quiz.quizlimitationsetting.time_limitation/10 && !this.timeWarn && this.quiz.quizlimitationsetting.is_notice_that_the_exam_is_about_to_end){
          this.timeWarn = this.quiz.quizlimitationsetting.is_notice_that_the_exam_is_about_to_end
          this.toastr.warning('زمان آزمون رو به اتمام است!', '')
        }
      }else{
        clearInterval(this.timerInterval)
        if(this.currentPage<this.questionLists.length)
          this.refreshComponent()
      }
    }, 1000)
  }
  getTime():string{
    return `${this.time>=3600?`${Math.floor(this.time/3600)}:`:``}${Math.floor(this.time%3600/60)}:${Math.floor(this.time%60)}`
  }
  refreshComponent(){
    this.dialog.open(
      ReportResultComponent,{
        data:{
          succesful:false,
          message:'زمان پاسخ به سوالات به اتمام رسیده است'
        }
      }
    ).afterClosed().subscribe(
      ()=>{
        this.changecanDeactivate.emit(false)
        this.router.navigate([this.router.url])
        this.time = this.quiz.quizlimitationsetting.time_limitation
      }
    )
  }
  updateData(data:IAnswer[]):void{
    let isFinish = this.isFinishQuiz
    data.forEach(element=>{
      this.updateOrAddAnswer(element)
    })
    this.isShowFinishQuizButton = this.isShowFinishButton()
    let validAnswersNumber:number = this.answers.filter(answer=>answer.valid==true).length
    this.progressBarValue = Math.floor(validAnswersNumber/this.questionQuantity*100)
    this.currentPage = isFinish?this.questionLists.length:this.isGoNextPage?this.currentPage+1:this.currentPage-1;
    // this.currentPage = this.isGoNextPage?this.currentPage+1:this.currentPage-1;
    if(this.currentPage==this.questionLists.length){
      clearInterval(this.timerInterval)
      this.unknownAnswers = this.answers.filter(answer=>answer.isUnknown==true)
      this.isUnknownQuestionQuantityValid = this.quiz.quizlimitationsetting.number_of_permitted_vague_question>=this.unknownAnswers.length
      if(!this.isUnknownQuestionQuantityValid)
        this.postUnknownQuestions(this.unknownAnswers).subscribe()
    }
  }
  updateOrAddAnswer(answer:IAnswer):void{
    let index:number = this.answers.findIndex(element=>element.id === answer.id)
    if(index==-1){
      this.answers.push(answer);
    }else{
      this.answers[index] = answer;
    }
  }
  
  postQuiz(){
    this.globalService.scrollToTopOfView('parent', 90)
    let unknownAnswers:IAnswer[] = this.answers.filter(answer=>answer.isUnknown==true)
    this.answers = this.answers.filter(answer=>answer.isUnknown==false&&answer.valid==true)
    this.currentPage++
    let passedTime = this.timer;
    clearInterval(this.timerInterval)
    let data: FormData = new FormData();
    console.log('timer', this.timer)
    data.append('time', passedTime.toString())
    this.answers.forEach(q=>{
      q.answer.forEach(a=>{
        data.append(q.id.toString(), a.toString())
      })
    })
    if(this.userInfo){
      data.append('name', `${this.userInfo.name}`)
      if(this.userInfo.email) data.append('email', `${this.userInfo.email.toString().replaceAll(' ','')}`)
      if(this.userInfo.phone_number) data.append('phone_number', `${this.userInfo.phone_number.toString().replaceAll(' ','')}`)
      
    }
    merge(this.getTakeATestObs(data), this.getQuizChartsObs(), this.getQuizCharTypeObs(), this.postUnknownQuestions(unknownAnswers)).pipe(
      finalize(()=>{
        let index:number = 0;
        from(this.resultCharts).pipe(
          concatMap((i:IResultChart)=>this.getResultChartObs(i.id, this.examResultId)),
          finalize(()=>{
            this.addCharTypeToChartResult()
            this.isResultLoaded = true;
            clearInterval(this.timerInterval)
            this.timerInterval.unsubscribe()
          })
        ).subscribe(
          (data)=>{
            this.convertedResultCharts.push(
              {
                output_type: this.quiz.output_type,
                chart_type: this.resultCharts[index].chart_type,
                chart_color:this.resultCharts[index]?.additional_fields?.chart_color,
                sortable:this.resultCharts[index].is_sorted_by_value,
                is_show_calculated_type:this.resultCharts[index].is_show_calculated_type,
                ...data
              }
            )
            index++
          }
        )
      })
    ).subscribe()
  }
  checkVagueQuestion():IAnswer[]{
    let vagueQuestion:IAnswer[] = []
    this.answers.forEach((answer:IAnswer)=>{
      if(answer.isUnknown)
        vagueQuestion.push(answer)
    })
    return vagueQuestion
  }
  getTakeATestObs(formData:any){
    return this.criteriaService.takeATest(this.quiz.username, formData).pipe(
      map((i:any)=>i['exam_result_id']),
      tap(i=>{
        this.examResultId = i;
      })
    )
  }
  getQuizChartsObs(){
    return this.criteriaService.getQuizCharts(this.quiz.username).pipe(
      tap((i:IResultChart[])=>{
        this.resultCharts = i;
      })
    )
  }
  getQuizCharTypeObs(){
    return this.criteriaService.getSingleMultiCriteriaCharType(this.quiz.username).pipe(
      tap((i:ICharType[])=>{
        this.charTypeList = i
      })
    )
  }
  postUnknownQuestions(answers:IAnswer[]){
    if(answers.length<=0)
      return of(null)
    let form:FormData = new FormData()
    let answersId:string[] = answers.map(answer=>answer.id.toString())
    answersId.forEach(answer=>{
      form.append('questions', answer)
    })
    if(this.userInfo && this.userInfo.name && this.userInfo.phone_number){
      form.append('user_info', `${this.userInfo.name.toString().replaceAll(' ','')},${this.userInfo.phone_number.toString().replaceAll(' ','')}`)
    }else{
      form.append('user_info', JSON.stringify(this.globalService.jwtService.getUsernameFromStorageToken()))
    }

    return this.criteriaService.postVagueQuestions(this.quiz.username, form)
  }
  getResultChartObs(chartId:number, returnedResultId:string){
    return this.criteriaService.getChartInfo(this.quiz.username, chartId, returnedResultId)
  }
  
  addCharTypeToChartResult(){
    this.convertedResultCharts.forEach((item:any)=>{
      let obj:any;
      let keys = Object.keys(item) 
      let values = Object.values(item)
      for(let i in keys){
        if(keys[i]!='chart_type' && keys[i]!='output_type' && keys[i]!='chart_color' && keys[i]!='sortable' && keys[i]!='is_show_calculated_type') {
          item[keys[i]].charType = this.findCharType(+keys[i])[0]
        }
      }
    })
  }
  goToFirstPage(){
    this.currentPage = 0;
    this.globalService.scrollToTopOfView('parent', 90)
    if(this.quiz.quizlimitationsetting.time_limitation>0)
      this.configTimer()
  }
  findCharType(id:number){
    return this.charTypeList.filter(element => +element.id === id)
  }
  exitQuiz(){
    this.changecanDeactivate.emit(false)
    this.router.navigate([this.router.url])
    this.time = this.quiz.quizlimitationsetting.time_limitation
  }
  finishQuiz(){
    // this.changecanDeactivate.emit(false)
    this.isFinishQuiz = true;
    this.changePage(true);
    this.isFinishQuiz = false;
  }
  getReduceUnknownQuestionConfig(){
    return {
      isShowTime: this.quiz.quizlimitationsetting.time_limitation>0,
      remainingTime: this.time,
      validQuantity: this.quiz.quizlimitationsetting.number_of_permitted_vague_question,
    }
  }
  endTime(){
    clearInterval(this.timerInterval)
    this.time = 0;
    this.refreshComponent()
  }
  getUnknownQuestions():(ISingleLikertQuestion|ISingleSortingQuestion|ISingleMultiOptionQuestion)[]{
    let questions:(ISingleLikertQuestion|ISingleSortingQuestion|ISingleMultiOptionQuestion)[] = []
    this.unknownAnswers.forEach(answer=>{
      this.questionLists.forEach(questionlist=>{
        questionlist.forEach(question=>{
          if(question.id==answer.id)
            questions.push(question)
        })
      })
    })
    return questions 
  }
  updateQuestions(answers:IAnswer[]){
    let index:number = 0;
    answers.forEach(answer => {
      index = this.answers.findIndex(a=>a.id==answer.id)
      this.answers[index] = answer;
    });
    this.currentPage = this.questionLists.length+1;
    this.postQuiz()
  }
  getQuestionIsRequired(id:number):boolean{
    let qList:any[] = this.questionLists.reduce((acc, val) => acc.concat(val), [])
    let index:number = qList.findIndex(q=>q.id==id)

    return qList[index].is_answer_required
  }
  isShowFinishButton():boolean{
    return this.answers.filter((a:IAnswer)=>{
      return this.getQuestionIsRequired(a.id) && !a.valid && !a.isUnknown
    }).length<=0 && this.answers.length >= this.questionLists.reduce((acc, val) => acc.concat(val), []).length
  }
  ngOnDestroy() {
    if (this.someSubscription) {
      this.someSubscription.unsubscribe();
    }
    clearInterval(this.timerInterval)
    // this.completeForm.setBackButton(null)
  }
}
